/**
 * 향후 Facade가 순서대로 실행할 단계 이름 (지금은 문서·로그용).
 * 실제 구현은 Strangler로 기존 DotSolarMap / store 호출을 이쪽으로 옮길 때 채움.
 */
export const PipelinePhase = Object.freeze({
  INTENT: 'intent',
  RESOLVE_SITE: 'resolve_site',
  ENSURE_DEFECT_TYPES: 'ensure_defect_types',
  BUILD_DEFECT_CODES: 'build_defect_codes',
  FETCH_WFS: 'fetch_wfs',
  FETCH_AI_LAYER: 'fetch_ai_layer',
  DONE: 'done'
});
